export const environment = {
  production: true,
  deploymentEnv: 'production',
  useEmulators: false,
  autoLogin: false,
  firebase: {
    apiKey: 'AIzaSyBzXMJ7E2OOqUAznuNtv-MebxIn4OrrMhk',
    authDomain: 'veo-dashboard.firebaseapp.com',
    projectId: 'veo-dashboard',
    storageBucket: 'veo-dashboard.firebasestorage.app',
    messagingSenderId: '997650150196',
    appId: '1:997650150196:web:2a1d37847ff8f12ef6ab61',
    measurementId: 'G-VDVD6PHJ2W',
    databaseId: 'production', // Use production Firestore database
  },
  auth: {
    passwordMinLength: 8,
    passwordResetUrl: 'https://veo-dashboard.web.app/login',
  },
  api: {
    baseUrl: 'https://monitorhvl.tugoo.io',
    sseBaseUrl: 'https://monitorhvl.tugoo.io',
    screenshotsBaseUrl: 'https://monitorhvl.tugoo.io',
  },
  // Google Maps API key (fetched from Remote Config in production)
  googleMapsApiKey: '',
  googleMapsMapId: '',
  monitoring: {
    enabled: true,
    sentryDsn: '',
    tracesSampleRate: 0.1,
  },
  // Not used in production (emulators are disabled)
  testUser: undefined as { email: string; password: string } | undefined,
  emulatorPorts: undefined as { auth: number; firestore: number } | undefined,
};
